export default "__VITE_ASSET__BwUd5XgO__"